import { FHIRURL } from "../utils/FHIRURL";

import { medicalsApi } from "../api/medicalsApi";
import { Reference } from "../types/reference";
import { SexualHistoryQuestionnaire } from "../types/socialHistory";

const findSexualHistory = async (
  encounterReference: Reference,
  patientReference: Reference,
) => {
  const SH_QUESTIONNAIRE_CODE = "371828001";
  const questionnaire = await medicalsApi.findQuestionnaireResponse(
    SH_QUESTIONNAIRE_CODE,
    {
      subject: patientReference.identifier,
      e: encounterReference?.identifier,
      "exclude-status": "entered-in-error",
    },
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    throw new Error(
      "Sexual history questionnaire is either more than or less than 1",
    );
  }

  return questionnaire[0];
};

const findQuestionnaire = async () => {
  const SH_QUESTIONNAIRE_CODE = "371828001";
  const ENTITY_TYPE = "questionnaire";
  const questionnaire = await medicalsApi.findEntities(
    { code: SH_QUESTIONNAIRE_CODE, status: "active" },
    ENTITY_TYPE,
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    throw new Error(
      "Sexual history questionnaire is either more than or less than 1",
    );
  }

  return questionnaire[0];
};

const createDefault = (
  questionnaire: SexualHistoryQuestionnaire,
  encounterReference: Reference,
  patientReference: Reference,
  authoredDate: Date,
  practitionerReference: Reference,
) => {
  return {
    ...questionnaire,
    questionnaire: new FHIRURL(`Questionnaire/${questionnaire.id}`, {
      version: questionnaire.version,
      code: questionnaire.code[0]?.code,
    }).url,

    status: "in-progress",
    encounter: encounterReference,
    subject: patientReference,
    authored: authoredDate || new Date(),
    author: practitionerReference,
  };
};

export const SexualHistoryManager = {
  findSexualHistory,
  findQuestionnaire,
  createDefault,
};
